import React from 'react';
import { ProgressSteps, ProgressStepsItem } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';
import { CandidateOpportunitiesConst } from '@axiom/const';

const {
  CandidateStatuses: {
    WarmedYes,
    Submitted,
    Interviewing,
    Selected,
    Engaged,
    Rejected,
  },
} = CandidateOpportunitiesConst;

const getProgressActiveStatus = (
  engagementDetails: CandidateEngagementDetails
) =>
  [Rejected].includes(engagementDetails.candidateStatus)
    ? engagementDetails.previousCandidateStatus
    : engagementDetails.candidateStatus;

export type EngagementProgressStepsProps = {
  engagement: CandidateEngagementDetails;
  name?: string;
};

export const EngagementProgressSteps: React.FC<
  EngagementProgressStepsProps
> = ({ engagement, name = 'ENGAGEMENT_PROGRESS_STEPS' }) => (
  <ProgressSteps
    completedStep={getProgressActiveStatus(engagement)}
    icon="checkmark"
    key={engagement.opportunity.id}
    name={name}
  >
    <ProgressStepsItem stepName={WarmedYes}>Share My Profile</ProgressStepsItem>
    <ProgressStepsItem stepName={Submitted}>Profile Shared</ProgressStepsItem>
    <ProgressStepsItem stepName={Interviewing}>Interviewing</ProgressStepsItem>
    <ProgressStepsItem stepName={Selected}>Selected</ProgressStepsItem>
    <ProgressStepsItem stepName={Engaged}>
      Awaiting Engagement
    </ProgressStepsItem>
  </ProgressSteps>
);
